import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/video-face-swap"
    exact
    path="/consumer/features/video-face-swap"
    component={AsyncPage}
  />,
];
